export default "__VITE_ASSET__DSiQM8FD__"